import styled from 'styled-components';

export const StyledShortcutGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
`;

export const StyledShortcutItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-3);
    background-color: var(--surface-hover);
    border-radius: var(--radius-md);
    transition: all var(--transition-fast);
    
    &:hover {
        background-color: var(--surface-active);
    }
    
    .shortcut-keys {
        display: flex;
        align-items: center;
        gap: var(--space-2);
    }
    
    .shortcut-plus {
        color: var(--text-tertiary);
        font-size: var(--text-sm);
        font-weight: var(--font-medium);
    }
    
    .shortcut-description {
        color: var(--text-secondary);
        font-size: var(--text-sm);
    }
`;

export const StyledShortcutKey = styled.kbd`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 28px;
    padding: 0 var(--space-2);
    background-color: var(--surface-default);
    border: 1px solid var(--border-default);
    border-bottom-width: 2px;
    border-radius: var(--radius-sm);
    font-size: var(--text-sm);
    font-weight: var(--font-semibold);
    font-family: var(--font-mono);
    color: var(--text-primary);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;
